import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a variant's supplement facts table.
 * Listens for variant update events and swaps in the re-rendered table
 * for the newly selected variant.
 */
class SupplementFacts extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  /**
   * Updates the supplement facts table for the selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  update = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const next = event.detail.data.html.querySelector(
      `supplement-facts[data-block-id="${this.dataset.blockId}"]`
    );

    if (!next) {
      // Selected variant has no supplement facts — clear the previous table.
      this.replaceChildren();
      return;
    }

    if (next.innerHTML !== this.innerHTML) {
      this.innerHTML = next.innerHTML;
    }
  };
}

if (!customElements.get('supplement-facts')) {
  customElements.define('supplement-facts', SupplementFacts);
}
